import {
  compose,
  graphql,
} from 'react-apollo'
import { deleteUserMutation } from '../mutations'
import { getUsersQuery } from '../queries'
import AdminUserListItem from '../components/adminUserListItem'

export default compose(
  graphql(getUsersQuery),
  graphql(deleteUserMutation, {
    name: 'deleteUserMutation',
    options: {
      refetchQueries: [{
        query: getUsersQuery,
      }],
    },
  }),
)(AdminUserListItem)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminUserListItem.js